import debounce from 'lodash/debounce';
import clamp from 'lodash/clamp';

export default defineNuxtPlugin(nuxtApp => {
  const showGrid = useShowGrid();

  const setViewportHeight = () => {
    let vh = 0.8;
    if (window.innerWidth >= 768) {
      vh = window.innerHeight / 1000;
    }

    document.body.style.setProperty('--vh', `${clamp(vh, -100, 1)}`);
  };

  setViewportHeight();

  window.addEventListener(
    'resize',
    debounce(() => setViewportHeight(), 50)
  );

  if (process.env.NODE_ENV === 'development') {
    document.addEventListener('keydown', event => {
      if (event.key === 'g' || event.code === 'KeyG') {
        showGrid.value = !showGrid.value;
      }
    });
  }

  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }
});
